module.exports = __webpack_public_path__ + "img/arloVideoDoorbell_V2.daf2dd22.png";